// frontend/src/utils/triviaUtils.js

console.log('[🔎 TriviaUtils loaded]');

function isTriviaQuestion(message) {
  try {
    const patterns = [
      /^who (is|was)/i,
      /^what (is|was)/i,
      /^when (did|was|is)/i,
      /^where (is|was)/i,
      /^how (many|much|long|far|often)/i,
      /^why (did|is|are|was|do|does|can|would)/i,
      /^name (the|a)/i,
      /\bcapital of\b/i,
      /\bUS president\b/i,
      /\bfirst\b.*\bwoman\b/i,
    ];
    const match = patterns.some((pattern) => pattern.test(message));
    console.log(`[✅ isTriviaQuestion] ${match} ← "${message}"`);
    return match;
  } catch (err) {
    console.error('[❌ isTriviaQuestion] Error:', err);
    return false;
  }
}

function isTriviaAnswer(message) {
  try {
    const indicators = [
      /\bwas\b.+\b(president|capital|year|place)\b/i,
      /\bit was\b/i,
      /\bi think (it|he|she|they) (was|is)\b/i,
      /\b(i guess|maybe|probably|sounds like)\b/i,
      /\b(hmm|wasn’t it|wasn't it|could be)\b/i,
      /^(that|this) (was|is) (easy|tough|tricky)/i,
    ];
    const match = indicators.some((pattern) => pattern.test(message));
    console.log(`[✅ isTriviaAnswer] ${match} ← "${message}"`);
    return match;
  } catch (err) {
    console.error('[❌ isTriviaAnswer] Error:', err);
    return false;
  }
}

async function handleTrivia({ message, context }) {
  console.log('[🧠 handleTrivia] Processing message:', message);

  // You could fetch from an API, use OpenAI, or return a static fallback
  return {
    shaped: `Hmm, I think that might be a trivia question, but I’m not totally sure. Want me to look it up?`,
    confidence: 0.7,
  };
}

export { isTriviaQuestion, isTriviaAnswer, handleTrivia };
